export default __webpack_public_path__ + "static/media/341.e631a43a.gif";